import { useNotificationWatcher } from '@/hooks/use-notification-watcher';
import { useMessagesWatcher } from '@/hooks/use-messages-watcher';

export function RealtimeWatchers() {
  useNotificationWatcher();
  useMessagesWatcher();
  return null;
}
